import { usePlansModal } from "@circle-react/components/shared/PlansModal";
import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";

export const SubscriptionCancelled = () => {
  const plansModal = usePlansModal();

  return (
    <Alert
      data-testid="plan-cancelled"
      variant="destructive"
      icon="triangle-exclamation"
      iconColor="danger"
      title={t("pricing_plans.plan_cancelled")}
      description={t("pricing_plans.to_access")}
      secondaryActionProps={{
        children: t("trial_banner.renew_plan"),
        onClick: () => void plansModal.show(),
      }}
    />
  );
};
